import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { fr } from 'date-fns/locale';

import AppRouter from './AppRouter';
import { AuthProvider } from './context/AuthContext';
import { PermissionsProvider } from './contexts/PermissionsContext';
import { SidebarProvider } from './contexts/SidebarContext';
import { TeamProvider } from './context/TeamContext';
import { DataProvider } from './contexts/DataProvider';
import { TechniciansProvider } from './contexts/TechniciansContext';
import { SkillsProvider } from './contexts/SkillsContext';
import { OnCallsProvider } from './contexts/OnCallsContext';
import { AbsencesProvider } from './contexts/AbsencesContext';
import store from './store';
import theme from './assets/styles/theme';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
            <CssBaseline />
            <AuthProvider>
                <PermissionsProvider>
                  <SidebarProvider>
                    <TeamProvider>
                      <DataProvider>
                        <TechniciansProvider>
                          <SkillsProvider>
                            <OnCallsProvider>
                              <AbsencesProvider>
                                <AppRouter />
                              </AbsencesProvider>
                            </OnCallsProvider>
                          </SkillsProvider>
                        </TechniciansProvider>
                      </DataProvider>
                    </TeamProvider>
                  </SidebarProvider>
                </PermissionsProvider>
            </AuthProvider>
          </LocalizationProvider>
        </ThemeProvider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);
